import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DashboardSingleContactListLeftContainerContactRow from './table-row'
import { appendDeletionArray, subtractDeletionArray } from '../../../../../redux/actions/single-contact-list'
import { Checkbox } from '../../../../library/checkbox'

import './style.scss'
import { TableLoader } from '../../../../library/table-loader'

const Index = ({searchQuery, maintainLayout}) => {

    const dispatch = useDispatch()

	const fetchLoading = useSelector(state => state.singleContactList.fetchRecords.loading)
	const records = useSelector(state => state.singleContactList.records)

    const deletions = useSelector(state => state.singleContactList.deletionArray)

    const [allSelected, setAllSelected] = useState(false)

    const clickSelectAll = e => {
        if(e.target.checked){
            setAllSelected(true)
            for(var record in records){
                if(!deletions.includes(records[record].id)){
                    dispatch(appendDeletionArray(records[record].id))
                }
            }
        } else {
            setAllSelected(false)
            for(var record in records){
                if(deletions.includes(records[record].id)){
                    dispatch(subtractDeletionArray(records[record].id))
                }
            }
        }
    }


	return(
		<div className="table-contact-list-container">
			<table>
				<tr>
                    <th><Checkbox onClick={(e) => clickSelectAll(e)} checked={allSelected} className="select-all-checkbox" type="checkbox" id="select"/></th>
					<th>Fornavn</th>
					<th>Etternavn</th>
                    <th>Telefon</th>
					<th>E-post</th>
                    <th>Handling</th>
				</tr>
                {records.map((record) => {
                    return(
                        <DashboardSingleContactListLeftContainerContactRow contact={record}/>
                    )
                })}
			</table>
			{fetchLoading && !maintainLayout ? <TableLoader/>:null}
		</div>
	)
}

export default Index




